export const environment = {
  prod: true,
  apiUrl: 'https://api.sbkash.com/api/sandbox',
  logs: true,
  sentryDSN: `https://1119a9e01f42dcabce9171f79bb40ce5@o4505662875500544.ingest.us.sentry.io/4509870643806208`,
};
